import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import Customform from "../../../ui/custom-form";
import CustomInput from "../../../ui/custom-input";
import {
  AddCameraApi,
  AddCameraTypeApi,
  fetchCameraTypeApi,
  GetDeviceById,
  UpdateCameraTypeApi,
} from "../../../api/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { PulseLoader } from "react-spinners";
import CustomButton from "../../../ui/custom-button";

function AddDevice() {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [cameraTypeList, setCameraTypeList] = useState([]);
  //console.log("cameraTypeList", cameraTypeList);
  const [loading, setLoading] = useState(false);
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  const [inputData, setInputData] = useState({
    user_name: "",
    password: "",
    public_static_ip: "",
    rtsp_port: "",
    camera_name: "",
    camera_type: "",
  });

  const isIPCamera = inputData.camera_type === "IP Camera";
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});

  useEffect(() => {
    if (data) {
      fetchdata();
    }
  }, []);

  const fetchdata = async () => {
    try {
      const detail = await GetDeviceById(data);
      if (detail?.data?.status === true) {
        const fetched = detail?.data?.data;
        console.log("Fetched detail", fetched);
        setInputData({
          user_name: fetched?.username || "",
          password: fetched?.password || "",
          public_static_ip: fetched?.ip || "",
          rtsp_port: fetched?.port || "",
          camera_name: fetched?.device_name || "",
          camera_type: fetched?.camera_type_id || "",
        });
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    const val =
      type === "radio"
        ? value === "true"
          ? true
          : value === "false"
          ? false
          : value
        : value;

    setInputData((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      username: inputData.user_name,
      password: inputData.password,
      ip: inputData.public_static_ip,
      port: inputData.rtsp_port,
      camera_type_id: inputData.camera_type,
      device_name: inputData.camera_name,
      device_description: "",
      user_id,
      organization_id,
    };

    setLoading(true);

    try {
      const res = data
        ? UpdateCameraTypeApi(data, user_id, organization_id, payload)
        : await AddCameraTypeApi(payload);
      if (res?.data?.status) {
        handleClose();
      }
    } catch (err) {
      console.error("Failed to add camera", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCameraTypes = async () => {
    try {
      const res = await fetchCameraTypeApi();
      if (res?.data?.status) {
        setCameraTypeList(res.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch camera types", error);
    }
  };

  useEffect(() => {
    fetchCameraTypes();
  }, []);

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">{data ? "Edit" : "Add"} Device</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Customform onSubmit={handleSubmit}>
          <div className="col-12 mb-3">
            <label className="form-label">Camera Name</label>
            <CustomInput
              name="camera_name"
              placeholder="Enter Camera Name"
              value={inputData.camera_name}
              onChange={handleChange}
            />
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Camera Type</label>
            <select
              name="camera_type"
              className="form-select"
              value={inputData.camera_type}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {cameraTypeList.map((type) => (
                <option key={type._id} value={type._id}>
                  {type.camera_type_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">User Name</label>
            <CustomInput
              name="user_name"
              placeholder="Enter User Name"
              value={inputData.user_name}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3 position-relative">
            <label className="form-label">Password</label>
            <div className="position-relative">
              <CustomInput
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="**********"
                value={inputData.password}
                onChange={handleChange}
              />
              <span
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#888",
                }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Public Static IP</label>
            <CustomInput
              name="public_static_ip"
              placeholder="Enter IP"
              value={inputData.public_static_ip}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">RTSP Port</label>
            <CustomInput
              name="rtsp_port"
              placeholder="Enter Port Number"
              value={inputData.rtsp_port}
              onChange={handleChange}
            />
          </div>

          <div className="bottomBtn d-flex justify-content-between mt-4">
            <button
              className="btn btn-outline-secondary px-4"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>

            {loading ? (
              <CustomButton type="submit" className="btnSubmit px-4 py-2">
                <PulseLoader color="#fff" size={8} />
              </CustomButton>
            ) : (
              <button className="btnSubmit px-4 py-2" type="submit">
                {data ? "Update" : "Submit"}
              </button>
            )}
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddDevice;
